import { inject, Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { UserRole } from '@libs/shared/api';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { NavigationService } from '@sprint-expert-manager/app/core/navigation/navigation.service';

import { pipe, switchMap } from 'rxjs';

interface NavigationItemCoreState {
  content: FuseNavigationItem[];
  isLoading: boolean;
  isLoaded: boolean;
  errorMessage: string;
}

const initialState: NavigationItemCoreState = {
  content: undefined,
  isLoading: false,
  isLoaded: false,
  errorMessage: '',
};

@Injectable({
  providedIn: 'root',
})
export class NavigationItemCoreStore {
  readonly #navigationService = inject(NavigationService);

  readonly state = signalState(initialState);
  readonly content$$ = this.state.content;
  readonly isLoading$$ = this.state.isLoading;
  readonly isLoaded$$ = this.state.isLoaded;
  readonly errorMessage$$ = this.state.errorMessage;

  constructor() {}

  fetchNavigationItems = rxMethod<{
    userRole: UserRole;
  }>(
    pipe(
      switchMap(payload =>
        this.#navigationService.getByUserRole(payload.userRole).pipe(
          tapResponse(
            (navigationItems: FuseNavigationItem[]) => {
              patchState(this.state, {
                content: navigationItems,
                isLoading: false,
                isLoaded: true,
                errorMessage: '',
              });
            },
            () => {
              patchState(this.state, {
                content: undefined,
                isLoading: false,
                isLoaded: false,
                errorMessage: "Couldn't fetch navigation items",
              });
            }
          )
        )
      )
    )
  );
}
